import React from 'react'
import propTypes from 'prop-types'

const _ = require("lodash");

const SupplyCompactTable = (props) => {
  const { columns, data, tableClassname, hideHeader } = props

  const buildRow = (dt) => (
    <tr key={_.uniqueId()}>
      {(columns || []).map(
        ({ centerData, selector, parsingFn, extraDataProps = {} }, i) => {

          const showRed = dt[selector] > 0 && i === columns.length - 1 || dt[selector] === 0 && i === columns.length - 2 || dt[selector] > 0 && i === columns.length - 4
          const applyPaddingLeft = i === columns.length - 2 || i === columns.length - 3 
          return (
            <td key={_.uniqueId()} style={{color: showRed && "#B42A27",paddingLeft: applyPaddingLeft && "1.5rem"}} className={centerData && 'align-center'} {...extraDataProps}>
              {parsingFn ? parsingFn(dt[selector]) : dt[selector]}
            </td>
          )
        }
      )}
    </tr>
  )

  return (
    <table className={`table-compact ${tableClassname || ''}`}>
      {!hideHeader && (
        <thead key={_.uniqueId()}>
          <tr>
            {(columns || []).map(
              ({ title, centerTitle, extraTitleProps = {} }, idx) => (
                <th
                  key={`${title}-${idx}`}
                
                  className={centerTitle && 'align-center'}
                  {...extraTitleProps}
                >
                  {title}
                </th>
              )
            )}
          </tr>
        </thead>
      )}
      <tbody key={_.uniqueId()} >{(data || []).map((dt) => buildRow(dt))}</tbody>
    </table>
  )
}

SupplyCompactTable.propTypes = {
  data: propTypes.array,
  columns: propTypes.array,
  tableClassname: propTypes.string,
  hideHeader: propTypes.bool,
}

export default SupplyCompactTable
